(() => {
  let alpineInitFired = false;
  const lateHandlers = [];

  document.addEventListener('alpine:init', () => {
    alpineInitFired = true;
    lateHandlers.splice(0).forEach((handler) => {
      try {
        handler();
      } catch (e) {
        console.error('[alpine-init-bridge]', e);
      }
    });
  }, { once: true });

  const originalAddEventListener = document.addEventListener.bind(document);

  document.addEventListener = function (type, listener, options) {
    if (type === 'alpine:init' && alpineInitFired && typeof listener === 'function') {
      try {
        listener.call(document, new Event('alpine:init'));
      } catch (e) {
        console.error('[alpine-init-bridge]', e);
      }
      return;
    }
    return originalAddEventListener(type, listener, options);
  };

  window.__onAlpineInit = (handler) => {
    if (typeof handler !== 'function') return;
    if (alpineInitFired) {
      try {
        handler();
      } catch (e) {
        console.error('[alpine-init-bridge]', e);
      }
    } else {
      document.addEventListener('alpine:init', handler, { once: true });
    }
  };
})();
